/** User-visible Summary subsection headers — aligned with step form cards. */
export const SUMMARY_SUBSECTION_DISPLAY_TITLES: Readonly<
  Record<string, string>
> = {
  requestor: 'Requestor',
  projectSummary: 'Project Summary',
  projectDetails: 'Project Details',
  scaleTimelineBudget: 'Feasibility',
  team: 'Team Information',
  siteDimensions: 'Site Dimensions',
  facilityPower: 'Facility Power',
  largeUps: 'Large UPS',
  powerDistribution: 'Power Distribution',
  requirements: 'Small UPS',
  coolingInformation: 'Cooling System',
  project: 'Liquid Cooling',
  racks: 'Racks',
  rackPowerInformation: 'Rack Power Information',
  additionalInformation: 'Additional Information',
};

export function getSummarySubsectionDisplayTitle(
  subsection: string | undefined,
): string | null {
  if (!subsection) {
    return null;
  }
  return SUMMARY_SUBSECTION_DISPLAY_TITLES[subsection] ?? null;
}
